<template>
  <b-container>
    <card>
      <h4 slot="header" class="card-title">{{ $t("message.addEmployee") }}</h4>
      <employee-form @submit="submit"></employee-form>
    </card>
  </b-container>
</template>

<script>
import { mapActions } from "vuex";
import { errorMessage } from "@/helpers/bookingSearch";
import EmployeeForm from "./EmployeeForm";

export default {
  components: {
    EmployeeForm
  },
  methods: {
    ...mapActions({
      createEmployee: "employees/createEmployee"
    }),
    async submit(employee) {
      try {
        await this.createEmployee(employee);
        this.$notify({
          type: "success",
          text: this.$t("message.employeeSaved")
        });
        this.$router.push("/management/employees");
      } catch (e) {
        this.$notify({
          type: "danger",
          title: this.$t("message.error"),
          text: errorMessage(e, "Could not save employee.")
        });
      }
    }
  }
};
</script>
